import { TableCell, TableRow } from '@mui/material'
import type { FC } from 'react'

import type { TransformedCompletedActivityData } from '@/lib/apollo/query/getCompletedActivitiesForUser'

import Row from './Row'
import { rowsPerPage } from './utils'

export interface Props {
  data: TransformedCompletedActivityData[]
}

const PageRows: FC<Props> = ({ data }) => {
  const hasUnusedRows = data.length < rowsPerPage

  return (
    <>
      {data.map((_, i) => (
        <Row key={i} activity={data[i]} />
      ))}
      {hasUnusedRows && (
        <TableRow>
          <TableCell colSpan={5} />
        </TableRow>
      )}
    </>
  )
}

export default PageRows
